import React from "react";
import styled, { css } from "styled-components";
import { UiConstants } from "../../../data/UiConstants";
import { NoMapElementIcon } from "../../editor/ElementIcons";
export const SelectorButton = styled.button.withConfig({
  displayName: "SelectorButton",
  componentId: "sc-9v9jj3-0"
})(["padding:0;width:140px;background-color:", ";overflow:hidden;overflow-wrap:anywhere;flex-shrink:0;&.invalid{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}"], props => props.bgColor, UiConstants.COLOR_VALUE_INVALID);
export const SelectorButtonContent = styled.div.withConfig({
  displayName: "SelectorButton__SelectorButtonContent",
  componentId: "sc-9v9jj3-1"
})(["position:relative;width:140px;display:flex;flex-direction:column;align-items:center;", " ", ""], props => !props.flexibleHeight && css(["height:75px;"]), props => props.flexibleHeight && css(["min-height:75px;"]));
const SelectorImage = styled.img.withConfig({
  displayName: "SelectorButton__SelectorImage",
  componentId: "sc-9v9jj3-2"
})(["max-width:80px;max-height:50px;object-fit:contain;min-width:0;min-height:0;flex-grow:1;"]);
const SecondaryText = styled.div.withConfig({
  displayName: "SelectorButton__SecondaryText",
  componentId: "sc-9v9jj3-3"
})(["font-size:x-small;"]);
export const SelectorButtonContentFilled = ({
  image,
  icon,
  text,
  secondaryText,
  flexibleHeight,
  children
}) => {
  return /*#__PURE__*/React.createElement(SelectorButtonContent, {
    flexibleHeight: flexibleHeight
  }, children, image && /*#__PURE__*/React.createElement(SelectorImage, {
    src: image
  }), !image && (icon || /*#__PURE__*/React.createElement(NoMapElementIcon, null)), /*#__PURE__*/React.createElement("div", null, text), secondaryText && /*#__PURE__*/React.createElement(SecondaryText, null, secondaryText));
};